import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NotificationServices from '../../services/NotificationServices';
import Pagetitle from '../../component/PageTitle';

function AddNotification() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    title: '',
    message: '',
    image: null, // Initialize as null instead of an empty string
    link: '',
    userFor:''
    
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.svg'); 

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues(prevState => ({
        ...prevState,
        image: file,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        // Check if the value is not null or undefined
        if (formValues[key] !== null && formValues[key] !== undefined) {
          formData.append(key, formValues[key]);
        }
      }

     

      const response = await NotificationServices.createNotification(formData);
 
      alert('Notification Added Successfully');
      navigate('/notification-list');

    } catch (error) {
      console.error('Failed to add notification', error);
      alert('Failed to add Notification');
    }
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box">
        <div className="container-box-top-header justify-content-end">
          <div className="sub-title-box-right">
            <Link className="site-btn-green" to="/notification-list">Notification List</Link>
          </div>
        </div>
        <div className="container-box-inner px-4">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="input-field">
                    <label>Title*</label>
                    <input 
                      type="text" 
                      name="title" 
                      className="form-control" 
                      value={formValues.title}
                      onChange={handleInputChange} 
                      placeholder="New Title"
                      required 
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Select Type*</label>
                      <select className="form-control" value={formValues.userFor} 
                        onChange={handleInputChange} name="userFor" required>
                        <option >Select User</option>
                        <option value="All">All</option>
                        <option value="User">User</option>
                        <option value="Investor">Investor</option>
                        {/* <option value="serviceCenter">Service Center</option>
                        <option value="manufacturer">manufacturer</option> */}
                      </select>
                      
                    </div>
                  </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Description*</label>
                    <textarea 
                      className="form-control video-desc" 
                      name="message" 
                      value={formValues.message}
                      onChange={handleInputChange} 
                      placeholder='Description' 
                      required
                    />
                  </div>
                </div>
              
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Upload <span className="red">*</span></label>
                    <input 
                      type="file" 
                      name="image" 
                      className="form-control" 
                      onChange={handleFileChange} 
                      required
                    />
                    <div className="file-preview">
                      <img id="uploadFile" src={previewImage} alt="Preview" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field">
                    <label>Redirect Url</label>
                    <input 
                      type="text" 
                      name="link" 
                      className="form-control" 
                      value={formValues.link}
                      onChange={handleInputChange} 
                      placeholder="Redirect Url" 
                    />
                  </div>
                </div>
              </div>
              <button className="site-btn-green" type="submit">
                Send Notification
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNotification;
